<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vyV20U/tc-custom/9781460388808.jpg?1728726247384" alt="This image is the cover for the book Amish Noel, The Amish Bachelors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amish Noel, The Amish Bachelors
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: Will his scandalous past douse the spark growing between them?</b><br/><br/>Luke Bowman’s homecoming is turning Emma Swartzentruber’s carefully ordered world upside down. Gone is her rebellious girlhood crush, and in his place is a handsome man who seems committed to serving the community. Luke’s even agreed to work for Emma’s ill father, whose last wish is to see his daughter wedded to a stable, loving man. But Luke—a man who flirted with the outside world with disastrous consequences—is hardly marriage material for a good Amish woman. Yet this Christmas, when her family is flung into crisis, Emma will find that he may just be the one to capture her heart for good.<br/><br/><b>Praise for Patricia Davids’ novels</b><br/><br/>“Uplifting . . . will have fans of Amish romance eager to read more from Davids.” —<i>Publishers Weekly</i><br/><br/>“Patricia writes with heart, integrity and hope. Her stories both entertain and edify—the perfect combination.” —Kim Vogel Sawyer, bestselling author of <i>The Tapestry of Grace</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia Davids
      </h2>
      
      <p class="authorDescription body article">USA Today best-selling author Patricia Davids was born in Kansas. After forty years as an NICU nurse, Pat switched careers to become an inspirational writer. She now enjoys laid back life on a Kansas farm, spending time with her family and playing with her dog Sugar, who thinks fetch should be a twenty-four hour a day game. When not throwing a ball, Pat is happily dreaming up new stories where love and faith conquer all. Contact her at pat@patriciadavids.com.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69fbd690